import { Component, Input, OnInit } from '@angular/core';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { Visit } from '../../../../tmc-visit.model';
import { Clipboard } from '@angular/cdk/clipboard';
import { TranslationService } from '@sdbn/common';

export interface LogEntry {
  timestamp: string;
  displayText: string;
}

@Component({
  selector: 'app-visit-log',
  templateUrl: './visit-log.component.html',
  styleUrls: ['./visit-log.component.scss']
})
export class VisitLogComponent implements OnInit {

  visit: Visit;
  logEntries = new Array<LogEntry>();

  @Input('visit') set setVisit(visit: Visit) {
    this.visit = visit;
    this.logEntries = new Array<LogEntry>();

    for (const log of visit.visitLogs) {

      let displayText = this.translationService.translate('tmc-visit.entity.visit-log.activity-type.' + log.activityType);
      if (log.note != null) {
        displayText += ' - ' + log.note;
      }

      this.logEntries.push({
        timestamp: log.timestamp,
        displayText
      });
    }
  }

  constructor(
    private snackBar: MatSnackBar,
    private clipboard: Clipboard,
    public translationService: TranslationService) { }

  ngOnInit(): void {
  }

  public copyLogToClipboard() {

    let string = 'Visit Log - Visit ' + this.visit.id + '\n';

    for (let log of this.visit.visitLogs) {
      if (log.timestamp != null) {
        string += log.timestamp;
      }
      string += '   ';
      if (log.activityType != null) {
        string += this.fillWithBlancs(this.translationService.translate('tmc-visit.entity.visit-log.activity-type.' + log.activityType), 30);
      }

      if (log.note != null) {
        string += ' - ' + log.note;
      }

      string += '\n';

    }

    this.clipboard.copy(string);

    this.snackBar.open(this.translationService.translate('tmc.personalvisit.dialog.protocol.copied-to-clipboard'), null, {
      duration: 3000
    });
  }

  private fillWithBlancs(value: string, length: number): string {
    let result = value != null ? value : '';
    while (result.length < length) {
      result += ' ';
    }
    return result;
  }

}
